import { OfferingForm } from '@/components/features/offerings/OfferingForm'
import { NavHeader } from '@/components/features/shared/NavHeader'
import { OfferingDto } from '@/domain/offerings/offering'
import { useCreateOffering } from '@/hooks/api/useOfferings'
import { Paths } from '@/routes/paths'
import { useNavigate } from '@tanstack/react-router'
import { PageContainer } from '@/components/features/shared/PageContainer'

export const CreateOfferingPage = () => {
  const navigate = useNavigate()
  const createOffering = useCreateOffering()

  const handleSubmit = async (values: OfferingDto) => {
    try {
      await createOffering.mutateAsync(values)
      navigate({ to: `${Paths.Management.Offerings}` })
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancel = () => {
    navigate({ to: `${Paths.Management.Offerings}` })
  }

  return (
    <PageContainer>
      <NavHeader>
        <h1 className="text-2xl font-bold tracking-tight">Nuevo Servicio</h1>
      </NavHeader>
      <div className="py-6 max-w-4xl border p-6 rounded-xl">
        <OfferingForm
          onSubmit={handleSubmit}
          isSubmitting={createOffering.isPending}
          submitButtonText="Crear servicio"
          onCancel={handleCancel}
        />
      </div>
    </PageContainer>
  )
}
